import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AppgenAuditService } from '../service/app-gen-audit.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-configuration-audit',
  templateUrl: './configuration-audit.component.html',
  styleUrls: ['./configuration-audit.component.scss'],
})
export class ConfigurationAuditComponent implements OnInit {
  title: string = 'Audit Timeline';
  fromCaseView: boolean = false;
  changesortValue: any;
  changeValue: any;
  form: FormGroup;
  Sortbylist: any = [];

  constructor(
    public dialogRef: MatDialogRef<ConfigurationAuditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auditService: AppgenAuditService,
    private route: ActivatedRoute
  ) {
    this.form = new FormGroup({
      sortBy: new FormControl(null),
      filterBy: new FormControl(null),
      fromDate: new FormControl(null),
      toDate: new FormControl(null),
      name: new FormControl(null),
      eventType: new FormControl(null),
      order: new FormControl(null),
    });
  }

  auditList = [];

  auditData: any;
  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.title = params.formName ? params.formName : this.title;
    });
    this.auditData = [...this.data.auditData];
    let auditDataMapped = this.auditData
      .map((item:any) => {
        item.CHANGED_DATA = JSON.parse(
          item?.CHANGED_DATA?.value
            ? item?.CHANGED_DATA?.value
            : item?.CHANGED_DATA
        );
        return item;
      })
      .filter((x: { CHANGED_DATA: string | any[]; }) => x.CHANGED_DATA.length != 0);
    this.auditList = auditDataMapped;
  }

  SortChange(e: { value: any; }) {
    console.log(e);
    this.changesortValue = e.value;
  }
  FilterChange(e: { value: any; }) {
    console.log(e);
    this.changeValue = e.value;
  }

  onReset() {
    // this.form.reset()
    this.changeValue = '';
    this.changesortValue = '';
    // this.OnSearch()
  }
}
